module.exports = __webpack_public_path__ + "static/joseph-d4b929d25b03209e9a8bc688f72bf1e7.jpg";